import script from "./BatchCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BatchCard.vue?vue&type=script&setup=true&lang=js"

import "./BatchCard.vue?vue&type=style&index=0&id=0ce95391&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ce95391"]])

export default __exports__